import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';


import {
  Container, Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
  View,
} from '@uncinc/react-drupal-core';
import { contactForm, DOMAIN_VNL } from '../../../../config/constants';

import {
  Share,
  NewsletterBlock
} from '../../../../components';


import './style.scss';

const NodeExpertDetail = ({ entity, className }) => {
  const { t } = useTranslation();
  const classes = classNames(className, 'NodeExpertDetail');
  const title = entity.getIn(['title', 0, 'value'], '');
  const phoneNumber = entity.getIn(['field_phone_number', 0, 'value'], '');
  const fun = entity.getIn(['field_function', 0, 'value'], '');
  const bio = entity.getIn(['field_bio', 0, 'value'], '');
  const linkedIn = entity.getIn(['field_link_to_page', 0, 'uri'], '');

  const allParagraphs = entity.getIn(['field_paragraphs'], Immutable.Map());

  const ctaParagraphs = allParagraphs.filter((item) => {
    const itemType = item.getIn(['entity', 'type', 0, 'target_id']);
    return itemType === 'cta';
  });

  const paragraphsWithoutCta = allParagraphs.filter((item) => {
    const itemType = item.getIn(['entity', 'type', 0, 'target_id']);
    return itemType !== 'cta';
  });

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
            <div className="NodeExpertDetail__Expert">
              {entity.getIn(['field_avatar', 0]) && (
                <div className="NodeExpertDetail__Expert__Avatar">
                  <Image
                    className="NodeExpertDetail__hero__image"
                    src={entity.getIn(['field_avatar', 0, 'styles', '1_1'])}
                    alt={entity.getIn(['field_avatar', 0, 'alt'], '')}
                  />
                </div>
              )}

              <div className="NodeExpertDetail__Expert__Details" id="main">
                <h1>{title}</h1>
                <h2 className="NodeExpertDetail__Expert__Details__Function">{fun}</h2>

                {config.get('CURRENT_DOMAIN') === DOMAIN_VNL && (
                  <div className="NodeExpertDetail__Expert__Details__Links">
                    {phoneNumber && (
                      <div className="NodeExpertDetail__Expert__Details__Links__Item NodeExpertDetail__Expert__Details__Links__Item--phoneNumber">
                        <i className="icon icon-phone" />
                        <a className="icon-after icon-chevron-right" href={`tel:${phoneNumber}`}>
                          {phoneNumber}
                        </a>
                      </div>
                    )}
                    {linkedIn && (
                      <div className="NodeExpertDetail__Expert__Details__Links__Item">
                        <i className="icon icon-linkedin" />
                        <a className="icon-after icon-chevron-right" href={linkedIn}>
                          LinkedIn
                        </a>
                      </div>
                    )}
                    <div className="NodeExpertDetail__Expert__Details__Links__Item">
                      <i className="icon icon-mail" />
                      <a className="icon-after icon-chevron-right" href={`${contactForm}?expert=${title}`}>
                        {t('buttons.email')}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {bio && (
              <div className="NodeExpertDetail__Expert__Body subheading2">
                {bio}
              </div>
            )}
          </div>

          {paragraphsWithoutCta.size > 0 && (
            <div className="NodeExpertDetail__Paragraphs">
              {
                paragraphsWithoutCta.map((item) => {
                  const paragraphId = item.get('target_id');
                  const paragraph = item.getIn(['entity']);

                  return (
                    <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
                  );
                })
              }
            </div>
          )}

        </div>
      </Container>

      <div className="NodeExpertDetail__get_started" id="NodeArticleDetail__get_started">
        <Container>
          <h2 className="NodeExpertDetail__get_started__title">{entity.getIn(['field_get_started_title', 0, 'value'])}</h2>
          <p className="NodeExpertDetail__get_started__subtitle">{entity.getIn(['field_get_started_subtitle', 0, 'value'])}</p>
          <div className="NodeExpertDetail__get_started__content">
            <View className="NodeExpertDetail__get_started__content" id="expert_content" onLoadMore display="block_1" args={[entity.getIn(['nid', 0, 'value'])]} />
            <div className="row">
              <View className="NodeExpertDetail__get_started__publications" id="expert_external_publications" display="block_1" args={[entity.getIn(['nid', 0, 'value'])]} />
            </div>
          </div>
        </Container>
      </div>

      <div className="TaxonomySubject__related_dossiers">
        <Container>
          <View id="expert_dossiers_related" display="block_1" args={[entity.getIn(['nid', 0, 'value'])]} />
        </Container>
      </div>

      {ctaParagraphs.size > 0 && (
        <div className="CTA__Paragraphs">
          {
            ctaParagraphs.map((item) => {
              const paragraphId = item.get('target_id');
              const paragraph = item.getIn(['entity']);

              return (
                <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
              );
            })
          }
        </div>
      )}

      <Container>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <Share pageTitle={entity.getIn(['title', 0, 'value'], '')} />
          </div>
        </div>
      </Container>

      {/* Newsletter subscription block */}
      <NewsletterBlock />
    </article>
  );
};

export default NodeExpertDetail;
